import { Widget } from "@typeform/embed-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { NavigationMenuLinks } from "@/components/NavigationMenu";
import { proServicesKeys } from "@/constants/proServices";
import { UserContext } from "@/contexts";
import { CustomUIMatch } from "@/hooks/useBreadcrumbs";

export type ProServiceKey = (typeof proServicesKeys)[number];

export const handle = {
  activeMenuLink: () => NavigationMenuLinks.options,
  breadcrumb: () => {
    const searchParams = new URLSearchParams(window.location.search);
    const optionKey = searchParams.get("option") || "";

    const isProService = proServicesKeys.includes(optionKey as ProServiceKey);

    const translationKey = isProService
      ? `options:byProServices.serviceList.${optionKey}.title`
      : `options:optionsList.${optionKey}.title`;

    return [
      {
        href: `/options/subscription?option=${optionKey}`,
        label: translationKey,
      },
    ];
  },
} as CustomUIMatch["handle"];

function SubscriptionOptions() {
  const { t } = useTranslation("options");
  const { user } = useContext(UserContext);

  const email = user?.email || "";
  const company = user?.company?.name || "";

  const searchParams = new URLSearchParams(window.location.search);
  const optionKey = searchParams.get("option") || "";

  const isProService = proServicesKeys.includes(optionKey as ProServiceKey);

  const optionTitle = isProService
    ? t(`options:byProServices.serviceList.${optionKey}.title`)
    : t(`options:optionsList.${optionKey}.title`);

  return (
    <div className="mt-md">
      <Widget
        id="PepaCSP4"
        hidden={{ email, company, option: optionTitle }}
        style={{ width: "100%", height: "600px" }}
      />
    </div>
  );
}

export default SubscriptionOptions;
